<div id="top"></div>
<div class="container-fluid p-0">
  <!--Signin/signup-->

  <div class="about">
    <div class="container" style="margin-top: 30px;">
      <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">

        <div class="col-sm-4 pb-3">



          <div class="container">
            <!--<div *ngIf="sign==1">
              <div *ngIf="!isSignedIn">
                <h2>Sign Up</h2>
                <input type="email" #emailSignup  placeholder="Email Address" />
                <input [type]="fieldTextType ? 'text' : 'password'" #passwordSignup placeholder="Password" />
                <mdb-icon far (click)="toggleFieldTextType()" class="childs" [ngClass]="{
                    'fa-eye-slash': !fieldTextType,
                    'fa-eye': fieldTextType
                    }">
                </mdb-icon>
                <button (click)="onSignup(emailSignup.value, passwordSignup.value)"  mdbBtn type="button" color="yellow"
                mdbWavesEffect>Sign Up</button> <a (click)="signUp()" class="mr-2"> Sign In</a>
              </div>
    
            </div>-->

            <div *ngIf="sign==0">
              <div *ngIf="!isSignedIn">
                <div class="title">
                  <h2 style="font-size: 40px;">Sign In</h2>
                </div>
                <form [formGroup]="formSignIn">
                  <!--Email-->
                  <input type="email" formControlName="email" #email placeholder="Email Address"
                     />
                  <!--Email-->

                  <!--Password-->
                  <input [type]="fieldTextType ? 'text' : 'password'" id="password"
                    formControlName="password" #password placeholder="Password" />
                  <br>

                  <mdb-icon far (click)="toggleFieldTextType()" class="child" [ngClass]="{
                    'fa-eye-slash': !fieldTextType,
                    'fa-eye': fieldTextType
                    }">
                  </mdb-icon>
                  <!--Password-->
                  <button (click)="onSignin(email.value, password.value)" mdbBtn type="button" color="yellow"
                    mdbWavesEffect>Sign
                    In</button> <!--<a (click)="signIn()" class="mr-2"> Sign Up</a>-->

                </form>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
  <!--Signin/signup-->
  <button (click)="topFunction()" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>

  <app-adminland *ngIf="isSignedIn" (isLogout)="handleLogout()"></app-adminland>
</div>

<!--
   <form [formGroup]="formContact" (ngSubmit)="onSubmit()">

                <input type="text" formControlName="fname" placeholder="First Name">
                <div *ngIf="fname?.invalid && fname?.touched">
                    <small class="text-danger" *ngIf="fname?.errors?.required"> First Name is
                        Required</small>
                    <small class="text-danger" *ngIf="fname?.errors?.minlength">First Name must have more then 3
                        letters</small>
                </div>

                <input type="text" formControlName="lname" placeholder="Last Name">
                <div *ngIf="lname?.invalid && lname?.touched">
                    <small class="text-danger" *ngIf="fname?.errors?.required">Last Name is
                        Required</small>
                    <small class="text-danger" *ngIf="fname?.errors?.minlength">Last Name must have more then 3
                        letters</small>
                </div>

                <input type="text" formControlName="email" placeholder="Email">
                <div *ngIf="email?.invalid && email?.touched">
                    <small class="text-danger" *ngIf="email?.errors?.required">Email Address is
                        Required</small>
                    <small class="text-danger" *ngIf="email?.errors?.minlength">Email Address must have more then 3
                        letters</small>
                </div>

                <input type="text" formControlName="subject" placeholder="Subject">
                <div *ngIf="subject?.invalid && subject?.touched">
                    <small class="text-danger" *ngIf="subject?.errors?.required">The Subject is
                        Required</small>
                    <small class="text-danger" *ngIf="subject?.errors?.minlength">The Subject must have more then 3
                        letters</small>
                </div>


                <textarea formControlName="message" placeholder="Write something.." style="height:200px"></textarea>
                <div *ngIf="message?.invalid && message?.touched">
                    <small class="text-danger" *ngIf="message?.errors?.required">Shouldn't be left empty</small>
                </div>


                <button type="submit" align="center" class="shopBtn">Send
                </button>

            </form>
        
-->